export const getQueryParams = (): Map<string, string> => {
  const search = window.location.href.split('?');
  if (search.length < 2) {
    return new Map();
  }
  const searchParams = new URLSearchParams(search[1]);
  const queryParams = new Map<string, string>();
  searchParams.forEach((value, key) => {
    queryParams.set(key, value);
  });
  return queryParams;
};

export const getQueryParam = (value: string): string => {
  return getQueryParams().get(value);
};
